import React from 'react';

import Page from '../components/global/page';
import Hero from '../components/hero';

import RotatingHero from '../components/lessons/rotating-hero';
import Opener from '../components/lessons/opener';
import Content from '../components/lessons/content';
import ProgramsCarousel from '../components/global/programs-carousel';
import Details from '../components/lessons/details';
import Map from '../components/lessons/map';
import Form from '../components/lessons/form';

export default ({ pageContext }) => {
	const { title, top, content, details } = pageContext;
	return (
		<Page title={title}>
			{top.bimgs ? (
				<RotatingHero backgrounds={top.bimgs} />
			) : (
				<Hero bimg={top.bimg} />
			)}
			<Opener quote={top.quote} author={top.author} />
			<Content title={content.title} copy={content.copy} more={content.more} />
			<ProgramsCarousel />
			<Details data={details} />
			<Map />
			<Form title={title} />
		</Page>
	);
};
